// extracted by mini-css-extract-plugin
export default {"wrapper":"TypographyMain_wrapper__lycmg","mText":"TypographyMain_mText__HA5Oo","mSecond":"TypographyMain_mSecond__0QtRj"};